import React from "react";
import dayjs from "dayjs";
import { Form } from "antd";
import Button from "@/common/elements/Button";
import CommonDatePicker from "@/common/elements/DatePicker";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { 
  StyledGridCol, 
  StyledGridRow, 
  StyledSectionHeading 
} from "@/common/styles";
import useDialog from "@/hooks/useDialog";
import { getOptionsFromRefList } from "@/util/common_function";

const JailIncidenHearingInformation = ({ data, onValuesChange, disabled = false }) => {
  const { showDialog } = useDialog();

  const combineDateTime = (date, time) => {
    return date && time ? dayjs(`${date} ${time}`, "MM/DD/YYYY HH:mm") : null;
  };

  const initialValues = {
    hearingInformation: data?.pendingHearing || "",
    startDateTime: combineDateTime(data?.hearingStartDate, data?.hearingStartTime),
    hearingDueDateTime: combineDateTime(data?.hearingDueDate, data?.hearingDueTime),
    hearingDateTime: combineDateTime(data?.hearingDate, data?.hearingTime),
    hearingOfficer: data?.hearingOfficerStaffID || "",
    reviewOfficer: data?.reviewOfficerStaffID || "",
    results: data?.jailIncidentsResults || "",
    comments: data?.hearingComments || "",
    penaltyLength: data?.penaltyLength || "",
    penaltyStartDateTime: combineDateTime(data?.penaltyStartDate, data?.penaltyStartTime),
    penaltyEndDateTime: combineDateTime(data?.penaltyEndDate, data?.penaltyEndTime),
  };

  const onHandleViewComment = () => {
    showDialog("info", {
      content: initialValues.comments,
      confirmButtonText: "Ok",
    });
  };

  return (
    <>
      <StyledSectionHeading marginTop="20px">
        <span>Hearing Information</span>
      </StyledSectionHeading>
      
      <Form
        name="jailIncidenHearingInformation"
        initialValues={initialValues}
        onValuesChange={onValuesChange}
      >
        {/* Hearing Information Text */}
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={6}>
            <FormItem label="Hearing Information" name="hearingInformation">
              <TextField disabled={disabled} />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>

        {/* Date/Time Section */}
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={7}>
            <FormItem label="Start Date/Time" name="startDateTime">
              <CommonDatePicker showTime={true} format="MM/DD/YYYY HH:mm" disabled={disabled} />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={7}>
            <FormItem label="Hearing Due Date/Time" name="hearingDueDateTime">
              <CommonDatePicker showTime={true} format="MM/DD/YYYY HH:mm" disabled={disabled} />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>

        <StyledGridRow gutter={16}>
          <StyledGridCol lg={7}>
            <FormItem label="Hearing Date/Time" name="hearingDateTime">
              <CommonDatePicker showTime={true} format="MM/DD/YYYY HH:mm" disabled={disabled} />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem label="Hearing Officer" name="hearingOfficer">
              <Select 
                options={getOptionsFromRefList("Staff", false, false, true)}
                disabled={disabled}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem label="Review Officer" name="reviewOfficer">
              <Select 
                options={getOptionsFromRefList("Staff", false, false, true)}
                disabled={disabled}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={5}>
            <FormItem label="Results" name="results">
              <Select 
                options={getOptionsFromRefList("JailIncidentsResults", false, false, true)}
                disabled={disabled}
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>

        {/* Comments Section */}
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={24} style={{ marginTop: "12px", marginBottom: "15px" }}>
            <FormItem label="Comments" name="comments">
              <TextField inputType="textarea" rows="3" disabled={disabled} />
            </FormItem>
            <Button 
              type="secondary" 
              color="secondary" 
              onClick={onHandleViewComment}
            >
              View Comments
            </Button>
          </StyledGridCol>
        </StyledGridRow>

        {/* Penalty Section */}
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={6}>
            <FormItem label="Penalty Length" name="penaltyLength">
              <TextField disabled={disabled} />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem label="Start Date/Time" name="penaltyStartDateTime">
              <CommonDatePicker showTime={true} format="MM/DD/YYYY HH:mm" disabled={disabled} />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol lg={6}>
            <FormItem label="End Date/Time" name="penaltyEndDateTime">
              <CommonDatePicker showTime={true} format="MM/DD/YYYY HH:mm" disabled={disabled} />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
    </>
  );
};

export default JailIncidenHearingInformation;
